var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',{staticClass:"public-form-page"},[_c('v-container',{staticClass:"py-8 py-md-12",staticStyle:{"max-width":"720px"}},[_c('v-card',{staticClass:"pa-4 pa-md-10",attrs:{"outlined":"","rounded":"lg"}},[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }